import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Link } from 'react-router-dom';
import '../../css/table.css';
import { get } from 'lodash';
import { getComparator, stableSort, TableComponent } from '../../Common/Table';
import { useState, useRef } from 'react';
import { Tooltip } from '@mui/material';
import { IoEye } from 'react-icons/io5';
import SelectDropdown from '../../Common/SelectDropdown';
import { grievanceTableHeader } from '../../Fields/grievanceFields';
import { useMediaQuery } from 'react-responsive';
import TableCard from '../../Common/TableCard';
import { useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { FaDownload } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import DeleteModal from '../../Common/DeleteModal';
import { MdDelete } from 'react-icons/md';
import { deleteRequest, postRequest } from '../interceptor/interceptor';
import { DELETE_TICKET, S3_SIGNED_URL } from '../../apiConst';
import moment from 'moment';

export default function GmsList({
  tableRowsData,
  getListData,
  rowsPerPage,
  setRowsPerPage,
  totalCount,
  page,
  setPage,
  onEdit,
  onView,
  onStepperForm,
  register,
  errors,
}) {
  const isTabletMid = useMediaQuery({ query: '(max-width: 768px)' });
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('id');
  const [modal, setModal] = useState(false);
  const [dataId, setDataId] = useState('');
  const [searchVal, setSearchVal] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const headers = grievanceTableHeader;
  const { role } = useSelector((state) => state.user);
  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    await getListData(Number(newPage + 1), rowsPerPage, '');
  };

  const downloadFile = async (key) => {
    try {
      const payload = {
        keys: [key],
      };
      const urlToDownload = await postRequest(`${S3_SIGNED_URL}`, payload);
      console.log('🚀 ~ downloadFile ~ urlToDownload:', urlToDownload);
      if (urlToDownload && urlToDownload?.data[0]?.url) {
        window.open(urlToDownload?.data[0]?.url);
      }
    } catch (error) {
      console.log('🚀 ~ downloadFile ~ error:', error);
    }
  };

  const onDelete = (id) => {
    setIsLoading(true);
    deleteRequest(`${DELETE_TICKET}${id}`)
      .then((res) => {
        setModal(false);
        setIsLoading(false);
        toast.success('Ticket Deleted Successfully');
        getListData();
      })
      .catch((error) => {
        setModal(false);
        console.log('error', error);
        setIsLoading(false);
      });
  };

  const openModal = (item) => {
    setModal(true);
    setDataId(item?.ticketNo);
  };

  const handleChangeRowsPerPage = (event) => {
    console.log('event' + event.target.value);
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    getListData(1, parseInt(event.target.value), '');
  };

  const handleSearchFieldDropdown = (e) => {
    getListData(1, rowsPerPage, searchVal, e.target.value);
  };

  const componentDisplay = () => {
    const cells = headers?.filter(
      (cell) =>
        cell.id === 'ticketNo' ||
        cell.id === 'requestTitle' ||
        cell.id === 'applicantName' ||
        cell.id === 'ticketCreatedBy' ||
        // cell.id === "requestType" ||
        cell.id === 'assignedTo' ||
        cell.id === 'referralName'
    );
    return (
      <div className="lg:mr-3 lg:w-52 text-center mb-[-15px] w-96">
        <DeleteModal
          dataId={dataId}
          firstButtonText={'Cancel'}
          secondButtonText={'Delete'}
          heading={'Confirm Delete'}
          body={<p>Do you want to delete the Request?</p>}
          modal={modal}
          pressSecondButton={(id) => onDelete(id)}
          pressFirstButton={() => setModal(false)}
          pressCloseButton={() => setModal(false)}
        />
        {headers.length > 0 && (
          <SelectDropdown
            fieldName="searchField"
            options={cells}
            optionsLabelKey="label"
            optionsValueKey="id"
            register={register}
            onChange={handleSearchFieldDropdown}
            errors={errors}
            fieldType="select"
            className="min-h-[auto] ml-3 w-48 border-1 bg-light py-2 text-sm text-gray-900 bg-white-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
            emptyOption={false}
          />
        )}
      </div>
    );
  };

  const getRowColorClass = (row) => {
    if (!row.issueOpen) return '';
    const issueOpenDate = moment(row.issueOpen);
    if (!issueOpenDate.isValid()) return '';

    const weeksOpen = moment().diff(issueOpenDate, 'weeks');

    if (row.ticketStatus === 'resolved') {
      return 'text-green-800'; // green bg + text
    }

    if (row.ticketStatus === 'backlog' && weeksOpen > 6) {
      return 'text-red-800';
    }

    if (row.ticketStatus === 'backlog' && weeksOpen >= 3 && weeksOpen <= 6) {
      return 'text-orange-800';
    }

    return ''; // default
  };

  return (
    <React.Fragment>
      <div className="taskList mx-2 shadow-lg bg-white rounded-lg mt-2 p-3">
        {isTabletMid ? (
          <div>
            <div className="grid grid-cols-1 pt-2 pb-2">
              <TableComponent
                numSelected={0}
                searchVal={searchVal}
                headingText={'Grievances'}
                order={order}
                searchBar={true}
                orderBy={orderBy}
                rowCount={tableRowsData.length || 0}
                tableRowsData={tableRowsData}
                headCells=""
                setOrder={setOrder}
                setOrderBy={setOrderBy}
                setSearchVal={setSearchVal}
                rowsPerPage={rowsPerPage}
                getAllData={getListData}
                componentDisplay={componentDisplay}
              >
                {tableRowsData &&
                  tableRowsData.length > 0 &&
                  tableRowsData.map((data) => (
                    <TableCard
                      key={data.ticketNo}
                      ticketNo={data.ticketNo}
                      requestTitle={data.requestTitle}
                      applicantName={data.applicantName}
                      // requestDescription={data?.requestDescription}
                      requestType={
                        data?.requestType || data?.privateRequestType
                      }
                      // issueOpen={data.issueOpen}
                      // ticketCreatedBy={data.ticketCreatedBy}
                      referralName={data?.referralName}
                      status={data.ticketStatus}
                      allowedRoles={['Super-Admin', 'Admin']}
                      role={role}
                      onEdit={
                        role !== 'Grievance-Data-Entry-Operator'
                          ? (e) => onStepperForm(data, e)
                          : (e) => onEdit(data, e)
                      }
                      onView={
                        role === 'Super-Admin' || role === 'Admin'
                          ? (e) => onView(data, e)
                          : undefined
                      }
                      onDownload={() => downloadFile(data?.attachment?.key)}
                    />
                  ))}
              </TableComponent>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={'Entries per page: '}
                labelDisplayedRows={({ from, to, count }) =>
                  `Showing ${from}-${to} of ${count} entries`
                }
              />
            </div>
          </div>
        ) : (
          <div style={{ width: '100%' }}>
            <TableComponent
              numSelected={0}
              searchVal={searchVal}
              headingText={'Grievances'}
              order={order}
              searchBar={true}
              orderBy={orderBy}
              rowCount={tableRowsData.length || 0}
              tableRowsData={tableRowsData}
              headCells={headers}
              setOrder={setOrder}
              setOrderBy={setOrderBy}
              setSearchVal={setSearchVal}
              rowsPerPage={rowsPerPage}
              getAllData={getListData}
              componentDisplay={componentDisplay}
            >
              <TableBody className="table-body">
                {tableRowsData &&
                  tableRowsData.length > 0 &&
                  stableSort(tableRowsData, getComparator(order, orderBy)).map(
                    (row, index) => {
                      return (
                        <TableRow hover tabIndex={-1} key={index}>
                          {headers.map((cell) => {
                            return (
                              <TableCell
                                key={cell.id + index}
                                className={
                                  cell.id === 'sno' ? 'sno-column' : ''
                                }
                              >
                                {cell.id === 'action' ? (
                                  <div className="justify-around items-center flex">
                                    <FaDownload
                                      className={`cursor-pointer transition ${getRowColorClass(
                                        row
                                      )}`}
                                      size={20}
                                      onClick={() =>
                                        downloadFile(row?.attachment?.key)
                                      }
                                    />

                                    {role !==
                                      'Grievance-Data-Entry-Operator' && (
                                      <div
                                        onClick={(e) => {
                                          // if (role !== "user") {
                                          onView(row, e);
                                          // }
                                        }}
                                        // style={{
                                        //   pointerEvents:
                                        //     role === "user" ? "none" : "auto",
                                        //   opacity: role === "user" ? 0.5 : 1,
                                        // }}
                                      >
                                        <IoEye
                                          size={23}
                                          className={`cursor-pointer transition ${getRowColorClass(
                                            row
                                          )}`}
                                        />
                                      </div>
                                    )}
                                    {role === 'Super-Admin' && (
                                      <div
                                        onClick={(e) =>
                                          role === 'Super-Admin'
                                            ? openModal(row)
                                            : null
                                        }
                                      >
                                        <MdDelete
                                          size={25}
                                          disabled={role !== 'Super-Admin'}
                                          className={`hover:cursor-pointer ${
                                            role === 'Super-Admin'
                                              ? 'text-red-800'
                                              : 'text-gray-600'
                                          }`}
                                        />
                                      </div>
                                    )}
                                  </div>
                                ) : cell.id === 'sno' ? (
                                  index + 1
                                ) : cell.id === 'ticketNo' ? (
                                  <div
                                    className={`text-xs flex cursor-pointer font-montsettat font-bold ${getRowColorClass(
                                      row
                                    )}`}
                                    // style={{
                                    //   pointerEvents: "auto",
                                    //   // opacity: role === "user" ? 0.5 : 1,
                                    // }}
                                  >
                                    <div
                                      onClick={(e) =>
                                        role !==
                                          'Grievance-Data-Entry-Operator' &&
                                        get(row, 'ticketStatus') !== 'backlog'
                                          ? onStepperForm(row, e)
                                          : onEdit(row, e)
                                      }
                                    >
                                      {get(row, cell.id)}
                                    </div>
                                  </div>
                                ) : cell.id === 'ticketStatus' ? (
                                  <div
                                    className={`capitalize rounded-md px-2 py-1 text-sm font-bold ${getRowColorClass(
                                      row
                                    )}`}
                                  >
                                    {get(row, cell.id)}
                                  </div>
                                ) : cell.id === 'requestType' ? (
                                  <div className={`capitalize`}>
                                    {get(row, 'requestType') ||
                                      get(row, 'privateRequestType')}
                                  </div>
                                ) : cell.id === 'assignedTo' ? (
                                  // <div
                                  //   className={`justify-center flex capitalize
                                  //    hover:font-bold`}
                                  // >
                                  get(row, cell.id)?.split('@')[0]
                                ) : cell.id === 'requestTitle' ? (
                                  (() => {
                                    const fullText = get(row, cell.id) || '';

                                    // Capitalize every word
                                    const capitalizeWords = (text) =>
                                      text
                                        .toLowerCase()
                                        .split(' ')
                                        .map(
                                          (word) =>
                                            word.charAt(0).toUpperCase() +
                                            word.slice(1)
                                        )
                                        .join(' ');

                                    const capitalizedFullText =
                                      capitalizeWords(fullText);
                                    const displayText =
                                      capitalizedFullText.length > 40
                                        ? capitalizedFullText.slice(0, 40) +
                                          '...'
                                        : capitalizedFullText;

                                    return capitalizedFullText.length > 40 ? (
                                      <Tooltip title={capitalizedFullText}>
                                        <span>{displayText}</span>
                                      </Tooltip>
                                    ) : (
                                      <span>{displayText}</span>
                                    );
                                  })()
                                ) : cell.id === 'applicantName' ? (
                                  (() => {
                                    const fullText = get(row, cell.id) || '';
                                    const displayText =
                                      fullText.length > 15
                                        ? fullText.slice(0, 15) + '...'
                                        : fullText;

                                    return fullText.length > 15 ? (
                                      <Tooltip title={fullText}>
                                        <span>{displayText}</span>
                                      </Tooltip>
                                    ) : (
                                      <span>{displayText}</span>
                                    );
                                  })()
                                ) : cell.id === 'referralName' ? (
                                  (() => {
                                    const fullText = get(row, cell.id) || '';
                                    const displayText =
                                      fullText.length > 15
                                        ? fullText.slice(0, 15) + '...'
                                        : fullText;

                                    return fullText.length > 15 ? (
                                      <Tooltip title={fullText}>
                                        <span>{displayText}</span>
                                      </Tooltip>
                                    ) : (
                                      <span>{displayText}</span>
                                    );
                                  })()
                                ) : (
                                  // </div>
                                  get(row, cell.id)
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    }
                  )}
              </TableBody>
            </TableComponent>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={'Entries per page: '}
              labelDisplayedRows={({ from, to, count }) =>
                `Showing ${from}-${to} of ${count} entries`
              }
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
